type Size = "s" | "m" | "l" | "xl"

export const getSizeClasses = (size: Size) => {
  const classes: string[] = []
  switch (size) {
    case "s":
      classes.push("h-[54px]")
      classes.push("text-base")
      break
    case "m":
      classes.push("h-ds-xl")
      classes.push("text-base")
      break
    case "l":
      classes.push("h-[56px]")
      classes.push("text-lg")
      break
    case "xl":
      classes.push("h-ds-xxl")
      classes.push("text-lg")
      break
  }
  return classes
}

export function getSelectSizeClasses(size: Size) {
  const classes: string[] = []
  switch (size) {
    case "s":
      classes.push("h-auto")
      classes.push("w-full")
      classes.push("size-small")
      classes.push("text-base")
      break
    case "m":
      classes.push("h-auto")
      classes.push("w-full")
      classes.push("size-medium")
      classes.push("text-base")
      break
    case "l":
      classes.push("h-auto")
      classes.push("w-full")
      classes.push("size-large")
      classes.push("text-lg")
      break
    case "xl":
      classes.push("h-auto")
      classes.push("w-full")
      classes.push("size-xl")
      classes.push("text-lg")
      break
  }
  return classes
}
